import adminErrorPage from "views/Pages/AdminErrorPage.js";
import ErrorPage from "views/Pages/ErrorPage.js";
import LoginPage from "views/Pages/LoginPage.js";
import VerificationPage from "views/Pages/VerificationPage";
import RegisterPage from "views/Pages/RegisterPage.js";
import UpdatePasswordPage from "views/Pages/UpdatePasswordPage";
import PricingPage from "views/Pages/PricingPage";
import ResetPasswordPage from "views/Pages/ResetPasswordPage";
import UserProfile from "views/Pages/UserProfile.js";
import QuApiVault from "views/Dashboard/QuApiVault.js";
import NewQuApiVault from "views/Dashboard/NewQuApiVault.js";

// core components/views for Admin layout
import Projects from "views/Dashboard/Projects";
import Experiments from "views/Dashboard/Experiments";
import UserTablePage from "views/Pages/UserTablePage";
import CourseProjects from "views/Dashboard/CourseProjects";
import CourseDesign from "views/Dashboard/Course/CourseDesign";
import ModulesDesign from "views/Dashboard/ModulesDesign";
import ModulesBoard from "views/Dashboard/Course/ModulesBoard";
import LandingPage from "views/Dashboard/LandingPage";
import LectureDesign from "views/Dashboard/Lecture/LectureDesign";
import LectureBoard from "views/Dashboard/Lecture/LectureBoard";
import WritingsBoard from "views/Dashboard/Writing/WritingsBoard";
import WritingPublisher from "views/Dashboard/Writing/WritingPublisher";
import LabsDesign from "views/Dashboard/Lab/LabsDesign";
import LabsBoard from "views/Dashboard/Lab/LabsBoard";
import ArtifactProjectsDesign from "views/Dashboard/ArtifactProject/ArtifactProjectsDesign";
import ArtifactProjectBoard from "views/Dashboard/ArtifactProject/ArtifactProjectBoard";
import PodcastDesign from "views/Dashboard/Podcast/PodcastDesign";
import PodcastBoard from "views/Dashboard/Podcast/PodcastBoard";
import QuTemplates from "views/Dashboard/QUTemplates";
import TemplateDesign from "views/Dashboard/Templates/TemplateDesign";
import ModelHomePage from "views/Pages/ModelHomePage";
import ModelPage from "views/Pages/ModelPage";
import HomePage from "views/Pages/HomePage";
import InvitationPage from "views/Pages/InvitationPage";
import DataGenerationBoard from "views/Dashboard/DataGeneration/DataGenerationBoard";
import DataGenerationPublisher from "views/Dashboard/DataGeneration/DataGenerationPublisher";
import FormsBoard from "views/Dashboard/Form/FormsBoard";
import FormDesignDashboard from "views/Dashboard/Form/FormDesignDashboard";
import PublishedForm from "views/Dashboard/Form/PublishedForm";
import ModelBoard from "views/Dashboard/Model Development/ModelBoard";
import ValidationBoard from "views/Dashboard/Model Validation/validationBoard";
import CodeDashboard from "views/Dashboard/CodesDashboard";
import ProjectsBoard from "views/Dashboard/ProjectsDashboard/ProjectsBoard";
import ProjectsDesignDashboard from "views/Dashboard/ProjectsDashboard/ProjectsDesignDashboard";
import ToolboxLandingPage from "views/Dashboard/ToolboxLandingPage";
import ModelDesignDashboard from "views/Dashboard/Model Development/ModelDesignDashboard";
import ValidationDesignDashboard from "views/Dashboard/Model Validation/ValidationDesignDashboard";

import { CaseStudyBoard } from "views/Dashboard/CaseStudy/CaseStudyBoard";
import CaseStudyDashboard from "views/Dashboard/CaseStudy/CaseStudyDashboard";
import SolutionGeneratorPage from "views/Dashboard/SolutionGenerator";
import PromptHub from "views/Dashboard/PromptHub/PromptHub";
import PromptEditor from "views/Dashboard/PromptHub/PromptEditor";

var dashRoutes = [
  {
    path: "/invite",
    hidden: true,
    name: "Invitation Page",
    component: InvitationPage,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/error-page",
    hidden: true,
    name: "error",
    component: ErrorPage,
    layout: "/auth",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/error-page",
    hidden: true,
    name: "error",
    component: adminErrorPage,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/login-page",
    hidden: true,
    name: "Login Page",
    component: LoginPage,
    layout: "/auth",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/verification-page",
    hidden: true,
    name: "Verification Page",
    component: VerificationPage,
    layout: "/auth",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/register-page",
    hidden: true,
    name: "Register Page",
    component: RegisterPage,
    layout: "/auth",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/reset-password-page",
    hidden: true,
    name: "Reset Password Page",
    component: ResetPasswordPage,
    layout: "/auth",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/landing-page",
    hidden: true,
    name: "Solution Accelerator",
    component: SolutionGeneratorPage,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/update-password-page",
    hidden: true,
    name: "Update Password Page",
    component: UpdatePasswordPage,
    layout: "/auth",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/pricing-page",
    hidden: true,
    name: "Pricing Page",
    component: PricingPage,
    layout: "/auth",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/user-page",
    hidden: true,
    name: "User Profile",
    mini: "UP",
    component: UserProfile,
    layout: "/create",
    redirect: "/auth/login-page",
    roles: ["user", "super_admin", "admin"],
  },

  {
    path: "/qu-api-vault",
    hidden: true,
    name: "QuApiVault",
    mini: "AV",
    // component: QuApiVault,
    component: NewQuApiVault,
    layout: "/create",
    redirect: "/auth/login-page",
    roles: ["super_admin"],
  },
  {
    path: "/users",
    hidden: false,
    name: "Users",
    mini: "U",
    component: UserTablePage,
    layout: "/create",
    redirect: "/auth/login-page",
    roles: ["super_admin"],
  },
  {
    path: "/toolbox-landing-page",
    name: "Toolbox Landing Page",
    hidden: true,
    component: LandingPage,
    layout: "/create",
    redirect: "/auth/login-page",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/qcreate-studio",
    name: "QCreate Studio",
    hidden: true,
    component: ToolboxLandingPage,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/home-page",
    name: "Home",
    hidden: true,
    component: HomePage,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/templates/:templateID",
    name: "Template",
    hidden: true,
    component: TemplateDesign,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/templates",
    name: "QuModelStudio",
    hidden: true,
    component: QuTemplates,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/model_home_page/:projectID/templates/:templateID",
    name: "Template",
    hidden: true,
    component: TemplateDesign,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/model_home_page/:projectID",
    name: "Project",
    hidden: true,
    component: ModelPage,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/model_home_page",
    name: "Model Projects",
    hidden: true,
    component: QuTemplates,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },

  {
    path: "/projects/experiments/:projectID",
    name: "Experiments",
    hidden: true,
    component: Experiments,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/research_report/:writingID",
    name: "Research Report",
    hidden: true,
    component: WritingPublisher,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/research_report",
    name: "Research Report Dashboard",
    hidden: true,
    component: WritingsBoard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/white_paper/:writingID",
    name: "White Paper",
    hidden: true,
    component: WritingPublisher,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },

  {
    path: "/white_paper",
    name: "White Paper Dashboard",
    hidden: true,
    component: WritingsBoard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/blog/:writingID",
    name: "Blog",
    hidden: true,
    component: WritingPublisher,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/blog",
    name: "Blog Dashboard",
    hidden: true,
    component: WritingsBoard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/news_letter/:writingID",
    name: "Newsletter",
    hidden: true,
    component: WritingPublisher,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/news_letter",
    name: "Newsletter Dashboard",
    hidden: true,
    component: WritingsBoard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/case_study/:caseStudyID",
    name: "Case Study",
    hidden: true,
    component: CaseStudyBoard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/case_study",
    name: "Case Study Dashboard",
    hidden: true,
    component: CaseStudyDashboard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/key_insights/:writingID",
    name: "Key Insights",
    hidden: true,
    component: WritingPublisher,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/key_insights",
    name: "Key Insights Dashboard",
    hidden: true,
    component: WritingsBoard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/handout/:writingID",
    name: "Handout",
    hidden: true,
    component: WritingPublisher,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/handout",
    name: "Handout Dashboard",
    hidden: true,
    component: WritingsBoard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/project_plan/:writingID",
    name: "Project Plan",
    hidden: true,
    component: WritingPublisher,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/project_plan",
    name: "Project Plan Dashboard",
    hidden: true,
    component: WritingsBoard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/course-design/courses/:courseID/module/:moduleID",
    name: "Module Design",
    hidden: true,
    component: ModulesBoard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/course-design/courses/:courseID",
    name: "Course Design Board",
    hidden: true,
    component: ModulesDesign,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/course-design",
    name: "Courses Design Dashboard",
    hidden: true,
    component: CourseDesign,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/project-design/projects/:projectID",
    name: "Project Board",
    hidden: true,
    component: ProjectsBoard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/project-design",
    name: "My Projects",
    hidden: true,
    component: ProjectsDesignDashboard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/templatedesign",
    name: "Template Design Dashboard",
    hidden: true,
    component: TemplateDesign,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/podcastdesign/podcast/:podcastID",
    name: "Podcast Design",
    hidden: true,
    component: PodcastBoard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/podcastdesign",
    name: "Podcast Design Dashboard",
    hidden: true,
    component: PodcastDesign,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/labdesign/lab/:labID",
    name: "Labs Design Dashboard",
    hidden: true,
    component: LabsBoard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/sessions/session/:projectId",
    name: "Session Board",
    hidden: true,
    component: ArtifactProjectBoard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/sessions",
    name: "Sessions",
    hidden: true,
    component: ArtifactProjectsDesign,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/model_development/model/:projectId",
    name: "Model Design Dashboard",
    hidden: true,
    component: ModelBoard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/model_development",
    name: "Model Design Dashboard",
    hidden: true,
    component: ModelDesignDashboard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/model_validation/model/:projectId",
    name: "Model Validation Board",
    hidden: true,
    component: ValidationBoard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/model_validation",
    name: "Model Validation Dashboard",
    hidden: true,
    component: ValidationDesignDashboard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/labdesign",
    name: "Concept Labs",
    hidden: true,
    component: LabsDesign,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/module/:lectureID",
    name: "Module Design Dashboard",
    hidden: true,
    component: LectureBoard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/module",
    name: "Module Design Dashboard",
    hidden: true,
    component: LectureDesign,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/synthetic_data_generation/:projectID",
    name: "Synthetic Data Generation",
    hidden: true,
    component: DataGenerationPublisher,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/synthetic_data_generation",
    name: "Synthetic Data Generation",
    hidden: true,
    component: DataGenerationBoard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/projects",
    name: "Projects",
    hidden: true,
    component: Projects,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/courseprojects",
    name: "Courses",
    hidden: true,
    component: CourseProjects,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/form-design/:formID",
    name: "Forms Board",
    hidden: true,
    component: FormsBoard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/form-design",
    name: "Form Design Dashboard",
    hidden: true,
    component: FormDesignDashboard,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/published_form/:formID",
    name: "Published Form",
    hidden: true,
    component: PublishedForm,
    layout: "/create",
    roles: ["user", "super_admin", "admin"],
  },
  {
    path: "/codes",
    name: "Codes",
    hidden: true,
    component: CodeDashboard,
    layout: "/create",
    redirect: "/auth/login-page",
    roles: ["super_admin", "user"],
  },
  {
    path: "/prompt-hub/prompt-editor/:promptId",
    name: "Prompt Editor",
    hidden: true,
    component: PromptEditor,
    layout: "/create",
    roles: ["super_admin"],
  },
  {
    path: "/prompt-hub",
    name: "Prompt Hub",
    hidden: true,
    component: PromptHub,
    layout: "/create",
    roles: ["super_admin"],
  },

  // {
  //   collapse: true,
  //   hidden: true, //Disabled QuToolBox
  //   name: "QuToolBox",
  //   icon: AppsIcon,
  //   layout: "/create",
  //   views: [
  //     {
  //       path: "/QuToolBox/Data",
  //       name: "Data",
  //       icon: StorageIcon,
  //       component: QUApi,
  //       layout: "/create",
  //     },
  //     {
  //       path: "/QuToolBox/Explore",
  //       name: "Explore",
  //       icon: ExploreIcon,
  //       component: QUApi,
  //       layout: "/create",
  //     },
  //     {
  //       path: "/QuToolBox/Processing",
  //       name: "Data Processing",
  //       icon: CompareArrowsIcon,
  //       component: QUApi,
  //       layout: "/create",
  //     },
  //     {
  //       path: "/QuToolBox/Modeling-Tools",
  //       name: "Modeling Tools",
  //       icon: BuildIcon,
  //       component: QUApi,
  //       layout: "/create",
  //     },
  //     {
  //       path: "/QuToolBox/Models",
  //       name: "Models",
  //       icon: ViewModuleIcon,
  //       component: QUApi,
  //       layout: "/create",
  //     },
  //     {
  //       path: "/QuToolBox/Explain",
  //       name: "Explain",
  //       icon: AssessmentIcon,
  //       component: QUApi,
  //       layout: "/create",
  //     },
  //     {
  //       path: "/QuToolBox/Fairness",
  //       name: "Fairness and Bias",
  //       icon: ThumbsUpDownIcon,
  //       component: QUApi,
  //       layout: "/create",
  //     },
  //     {
  //       path: "/QuToolBox/Report",
  //       name: "Report",
  //       icon: TableChartIcon,
  //       component: QUApi,
  //       layout: "/create",
  //     },
  //     {
  //       path: "/QuToolBox/Audit-Checklist",
  //       name: "Audit Checklist",
  //       icon: PlaylistAddCheckIcon,
  //       component: APIDetails,
  //       layout: "/create",
  //     },
  //     {
  //       path: "/QuToolBox/Case-studies",
  //       name: "Case studies",
  //       icon: WorkIcon,
  //       component: QUApi,
  //       layout: "/create",
  //     },
  //     // {
  //     //   path: "/resources",
  //     //   name: "Resources",
  //     //   icon: WorkIcon,
  //     //   component: Resources,
  //     //   layout: "/create",
  //     // },
  //   ],
  // },
];
export default dashRoutes;
